import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCMJEOfUvtvm1Ckfq9YHerLwmLaMSli6Ls",
  authDomain: "audience-f2493.firebaseapp.com",
  databaseURL: "https://audience-f2493-default-rtdb.firebaseio.com",
  projectId: "audience-f2493",
  storageBucket: "audience-f2493.firebasestorage.app",
  messagingSenderId: "879357523367",
  appId: "1:879357523367:web:c690b604d9af696ecf3282"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

export default app; 